/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Type of destination.
 */
export const DestinationType = {
  Webhook: "webhook",
  AwsSqs: "aws_sqs",
  Rabbitmq: "rabbitmq",
  Hookdeck: "hookdeck",
  AwsKinesis: "aws_kinesis",
  AzureServicebus: "azure_servicebus",
  AwsS3: "aws_s3",
  GcpPubsub: "gcp_pubsub",
} as const;
/**
 * Type of destination.
 */
export type DestinationType = ClosedEnum<typeof DestinationType>;

/** @internal */
export const DestinationType$inboundSchema: z.ZodNativeEnum<
  typeof DestinationType
> = z.nativeEnum(DestinationType);
/** @internal */
export const DestinationType$outboundSchema: z.ZodNativeEnum<
  typeof DestinationType
> = DestinationType$inboundSchema;
